var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66927 3.33073V0.664062H5.33594V3.33073M1.33594 3.33073H6.66927V9.33073C6.66927 9.86116 6.45856 10.3699 6.08348 10.7449C5.70841 11.12 5.1997 11.3307 4.66927 11.3307H3.33594C2.8055 11.3307 2.2968 11.12 1.92172 10.7449C1.54665 10.3699 1.33594 9.86116 1.33594 9.33073V3.33073Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacicon);
export default __webpack_public_path__ + "static/media/macicon.084b2363f316aa3bed81b81fcfcd1695.svg";
export { ForwardRef as ReactComponent };